import { TranslationKeys } from '../types/Translations.type';
export const VIEW_PADDING = 18;
export const PAGE_PADDING = 10;
export const ASSET_TYPE = {
    PHOTO: 'photo',
    VIDEO: 'video',
    AUDIO: 'audio',
    WEBAPP: 'webapp',
    DOCUMENT: 'document',
    RAW: 'raw',
    '3D-MODEL': '3d-model',
    MEETING_VIDEO: 'meeting-video',
    PERSONAL_VIDEO_RECORDING: 'personal-video-recording',
    URL: 'url',
    PAGE: 'page',
    SCORM: 'scorm'
};
export const VIEWS_TO_PRELOAD_PER_ASSET_TYPE_IN_HORIZONTAL_LAYOUT = {
    [ASSET_TYPE.PHOTO]: 1,
    [ASSET_TYPE.VIDEO]: 0,
    [ASSET_TYPE.AUDIO]: 0,
    [ASSET_TYPE.WEBAPP]: 0,
    [ASSET_TYPE.DOCUMENT]: 0,
    [ASSET_TYPE.RAW]: 0,
    [ASSET_TYPE['3D-MODEL']]: 0,
    [ASSET_TYPE.MEETING_VIDEO]: 0,
    [ASSET_TYPE.PERSONAL_VIDEO_RECORDING]: 0,
    [ASSET_TYPE.URL]: 0,
    [ASSET_TYPE.PAGE]: 0,
    [ASSET_TYPE.SCORM]: 0
};
// DOCUMENT SHOULD NEVER BE ADDED HERE AS THE RENDERER PERSISTS DATA SO CANNOT BE DESTROYED!!
export const ASSET_TYPES_WITH_MAX_1_RENDERER_IN_HORIZONTAL_LAYOUT = [
    ASSET_TYPE.AUDIO,
    ASSET_TYPE.VIDEO,
    ASSET_TYPE.MEETING_VIDEO,
    ASSET_TYPE.PERSONAL_VIDEO_RECORDING,
    ASSET_TYPE.WEBAPP,
    ASSET_TYPE.SCORM,
    ASSET_TYPE.PAGE,
    ASSET_TYPE.URL,
    ASSET_TYPE['3D-MODEL'],
    ASSET_TYPE.RAW
];
export const PRESENTATION_TYPE = {
    PDF_LOCAL: 'pdf_local',
    PDF_PAGE_LOCAL: 'pdf_page_local',
    UNPROCESSED: 'unprocessed',
    ORIGINAL: 'original',
    PROCESSED: 'processed',
    WEBAPP: 'webapp',
    PREVIEW: 'preview',
    ERROR: 'error',
    PREVIEW_PAGE_LOCAL: 'preview_page_local',
    PREVIEW_PAGE_PROGRESSIVE_LOCAL: 'preview_page_progressive_local',
    PREVIEW_PAGE_LOSSLESS_PROGRESSIVE_LOCAL: 'preview_page_lossless_progressive_local',
    URL: 'url',
    PAGE: 'page',
    MANIFEST: 'manifest'
};
export const SUPPORTED_PRESENTATION_TYPES = [
    PRESENTATION_TYPE.ERROR,
    PRESENTATION_TYPE.PDF_LOCAL,
    PRESENTATION_TYPE.PDF_PAGE_LOCAL,
    PRESENTATION_TYPE.ORIGINAL,
    PRESENTATION_TYPE.PROCESSED,
    PRESENTATION_TYPE.WEBAPP,
    PRESENTATION_TYPE.PREVIEW_PAGE_LOCAL,
    PRESENTATION_TYPE.PREVIEW_PAGE_PROGRESSIVE_LOCAL,
    PRESENTATION_TYPE.PREVIEW_PAGE_LOSSLESS_PROGRESSIVE_LOCAL,
    PRESENTATION_TYPE.URL,
    PRESENTATION_TYPE.PAGE,
    PRESENTATION_TYPE.MANIFEST
];
export const PRESENTATION_RENDERERS = {
    IMAGE: 'IMAGE',
    AUDIO: 'AUDIO',
    VIDEO: 'VIDEO',
    NEW_WINDOW: 'NEW_WINDOW',
    IFRAME: 'IFRAME',
    OBSERVABLE_DIMENSIONS_IFRAME: 'OBSERVABLE_DIMENSIONS_IFRAME',
    PDFJS: 'PDFJS',
    ASSET_VIEWER: 'ASSET_VIEWER',
    PDF_VIEWER: 'PDF_VIEWER',
    PREVIEW: 'PREVIEW',
    THUMBNAIL_ERROR: 'THUMBAIL_ERROR',
    ERROR: 'ERROR',
    URL: 'URL',
    URL_IFRAME: 'URL_IFRAME',
    THREEJS: 'THREEJS'
};
export const PRESENTATION_ACTIONS = {};
PRESENTATION_ACTIONS[PRESENTATION_TYPE.PAGE] = 'PAGE_FETCH_DATA';
// Legacy see ViewerEvents.type
export const VIEWER_EVENTS = {
    VIEWPORT_CHANGE: 'VIEWPORT_CHANGE',
    FOCUS_CHANGE: 'FOCUS_CHANGE',
    PREVIEW_RENDERED: 'PREVIEW_RENDERED',
    VIEW_RENDERED: 'VIEW_RENDERED',
    RENDERED_VIEW_FOCUS: 'RENDERED_VIEW_FOCUS',
    RENDERED_PREVIEW_FOCUS: 'RENDERED_PREVIEW_FOCUS',
    ADD_VIEWS: 'ADD_VIEWS',
    RESIZE: 'RESIZE',
    ZOOM: 'ZOOM',
    SWIPE: 'SWIPE',
    DOWNLOAD_ASSET: 'DOWNLOAD_ASSET',
    PLAYBACK_START: 'PLAYBACK_START',
    PLAYBACK_PAUSE: 'PLAYBACK_PAUSE',
    PLAYBACK_END: 'PLAYBACK_END',
    WEBAPP_OPEN: 'WEBAPP_OPEN',
    WEBAPP_CLOSE: 'WEBAPP_CLOSE',
    SET_VIEW: 'SET_VIEW',
    FULLSCREEN_CHANGE: 'FULLSCREEN_CHANGE',
    TOGGLE_FULLSCREEN: 'TOGGLE_FULLSCREEN',
    TOGGLE_VIEW_MODE: 'TOGGLE_VIEW_MODE',
    UPDATE: 'UPDATE',
    NAVIGATE_TO_PAGE: 'NAVIGATE_TO_PAGE',
    PUBLIC_FOCUS_CHANGE: 'PUBLIC_FOCUS_CHANGE',
    PUBLIC_RENDERED_VIEW_FOCUS: 'PUBLIC_RENDERED_VIEW_FOCUS',
    PUBLIC_RENDERED_PREVIEW_FOCUS: 'PUBLIC_RENDERED_PREVIEW_FOCUS',
    SELECT_VIEW: 'SELECT_VIEW',
    DESELECT_VIEW: 'DESELECT_VIEW',
    URL_ASSET_CLICKED: 'URL_ASSET_CLICKED',
    START_LOADING_3D_MODEL: 'START_LOADING_3D_MODEL',
    START_VIEWING_3D_MODEL: 'START_VIEWING_3D_MODEL',
    STOP_VIEWING_3D_MODEL: 'STOP_VIEWING_3D_MODEL',
    OPEN_IN_OFFICE_ONLINE: 'OPEN_IN_OFFICE_ONLINE'
};
// Legacy see RenderState.type
export const RENDER_STATES = {
    NONE: 'NONE',
    INITIAL: 'INITIAL',
    RUNNING: 'RUNNING',
    FINISHED: 'FINISHED',
    FAILED: 'FAILED'
};
export const PDF_RENDERER = {
    CANVAS: 'RAW_CANVAS' // Our own lightweight implementation, does not depend on pdf_viewer.js
};
export const PDF_RENDER_STRATEGY = {
    HIGH_PREVIEW: 'HIGH_PREVIEW',
    LOW_PREVIEW: 'LOW_PREVIEW',
    LOW_PREVIEW_HIGH_PREVIEW: 'LOW_PREVIEW_HIGH_PREVIEW',
    HIGH_PREVIEW_PDFJS: 'HIGH_PREVIEW_PDFJS',
    LOW_PREVIEW_PDFJS: 'LOW_PREVIEW_PDFJS',
    LOW_PREVIEW_HIGH_PREVIEW_PDFJS: 'LOW_PREVIEW_HIGHT_PREVIEW_PDFJS',
    HIGH_PREVIEW_NO_ANNOTATIONS: 'HIGH_PREVIEW_NO_ANNOTATIONS',
    LOW_PREVIEW_NO_ANNOTATIONS: 'LOW_PREVIEW_NO_ANNOTATIONS',
    LOW_PREVIEW_HIGH_PREVIEW_NO_ANNOTATIONS: 'LOW_PREVIEW_HIGH_PREVIEW_NO_ANNOTATIONS',
    PDFJS: 'PDFJS' // render with PDFJS, no preview
};
export const PDF_PRELOAD_STRATEGY = {
    FULL: 'FULL',
    LOW_PREVIEW: 'LOW_PREVIEW',
    HIGH_PREVIEW: 'HIGH_PREVIEW'
};
export const CANVAS_EMBED_STRATEGY = {
    CANVAS: 'CANVAS',
    DATA_URL_IMG: 'DATA_URL_IMG'
};
export const DEFAULT_PRESENTATION_RENDERERS_FOR_ASSET_TYPE_MAP = {
    [ASSET_TYPE.PHOTO]: [PRESENTATION_RENDERERS.IMAGE],
    [ASSET_TYPE.AUDIO]: [PRESENTATION_RENDERERS.AUDIO],
    [ASSET_TYPE.VIDEO]: [PRESENTATION_RENDERERS.VIDEO],
    [ASSET_TYPE.WEBAPP]: [PRESENTATION_RENDERERS.NEW_WINDOW],
    [ASSET_TYPE.PAGE]: [PRESENTATION_RENDERERS.IFRAME],
    [ASSET_TYPE.DOCUMENT]: [PRESENTATION_RENDERERS.PDFJS],
    [ASSET_TYPE['3D-MODEL']]: [PRESENTATION_RENDERERS.ERROR],
    [ASSET_TYPE.MEETING_VIDEO]: [PRESENTATION_RENDERERS.VIDEO],
    [ASSET_TYPE.PERSONAL_VIDEO_RECORDING]: [PRESENTATION_RENDERERS.VIDEO],
    [ASSET_TYPE.RAW]: [PRESENTATION_RENDERERS.ERROR],
    [ASSET_TYPE.URL]: [PRESENTATION_RENDERERS.URL]
};
export const DEFAULT_THUMBNAIL_PRESENTATION_RENDERERS_FOR_ASSET_TYPE_MAP = {
    [ASSET_TYPE.PHOTO]: [PRESENTATION_RENDERERS.PREVIEW],
    [ASSET_TYPE.AUDIO]: [PRESENTATION_RENDERERS.PREVIEW],
    [ASSET_TYPE.VIDEO]: [PRESENTATION_RENDERERS.PREVIEW],
    [ASSET_TYPE.WEBAPP]: [PRESENTATION_RENDERERS.PREVIEW],
    [ASSET_TYPE.SCORM]: [PRESENTATION_RENDERERS.PREVIEW],
    [ASSET_TYPE.PAGE]: [PRESENTATION_RENDERERS.PREVIEW],
    [ASSET_TYPE.DOCUMENT]: [PRESENTATION_RENDERERS.PREVIEW],
    [ASSET_TYPE['3D-MODEL']]: [PRESENTATION_RENDERERS.PREVIEW],
    [ASSET_TYPE.MEETING_VIDEO]: [PRESENTATION_RENDERERS.PREVIEW],
    [ASSET_TYPE.PERSONAL_VIDEO_RECORDING]: [PRESENTATION_RENDERERS.PREVIEW],
    [ASSET_TYPE.RAW]: [PRESENTATION_RENDERERS.PREVIEW],
    [ASSET_TYPE.URL]: [PRESENTATION_RENDERERS.PREVIEW]
};
export const LAYOUT = {
    VERTICAL: 'VERTICAL',
    VERTICAL_THUMBNAILS: 'VERTICAL_THUMBNAILS',
    HORIZONTAL: 'HORIZONTAL',
    HORIZONTAL_THUMBNAILS: 'HORIZONTAL_THUMBNAILS'
};
// TODO BASE_PATH in config
// export const BADGE_BASE_PATH = `${BASE_PATH}/badges`;
export const THUMB_PREFIX = '/ICON_thumbnail_';
export const THUMB_SUFFIX_SVG = '.svg';
export const BADGE_PREFIX = '/BADGE-';
export const BADGE_SUFFIX = '.svg';
export const ASSETS = {
    AUDIO: {
        NAME: 'audio'
    },
    VIDEO: {
        NAME: 'video'
    },
    IMAGE: {
        NAME: 'photo'
    },
    PHOTO: {
        NAME: 'photo'
    },
    URL: {
        NAME: 'url'
    },
    DOCUMENT: {
        NAME: 'document',
        EXCEL: {
            NAME: 'excel',
            EXT: {
                XLS: 'xls',
                XLSX: 'xlsx'
            }
        },
        DOCUMENT: {
            NAME: 'document',
            // temp: should be name
            WORD: 'word',
            EXT: {
                DOC: 'doc',
                DOCX: 'docx'
            }
        },
        PRESENTATION: {
            NAME: 'presentation',
            POWERPOINT: 'powerpoint',
            EXT: {
                PPT: 'ppt',
                PPTX: 'pptx',
                KEY: 'key',
                KEYNOTE: 'keynote'
            }
        },
        PDF: {
            NAME: 'pdf',
            EXT: {
                PDF: 'pdf'
            }
        },
        AUTOCAD: {
            NAME: 'autocad',
            EXT: {
                CAD: 'cad',
                DWG: 'dwg'
            }
        },
        DEFAULT: {
            NAME: 'document',
            EXT: {
                EPUB: 'epub',
                IBOOKS: 'ibooks',
                PAGES: 'pages'
            }
        }
    },
    WEBAPP: {
        NAME: 'webapp'
    },
    '3D-MODEL': {
        NAME: '3d-model'
    },
    'MEETING-VIDEO': {
        NAME: 'meeting-video'
    },
    'PERSONAL-VIDEO-RECORDING': {
        NAME: 'personal-video-recording'
    },
    RAW: {
        NAME: 'raw'
    },
    PAGE: {
        NAME: 'page'
    },
    SCORM: {
        NAME: 'webapp'
    }
};
export const VIEWER_TRACKING_EVENTS = {
    FOCUSED_ASSET_READY: 'FOCUSED_ASSET_READY'
};
export const NO_URL = 'No url provided';
export const THREE_JS_DEPS_KEYS = {
    THREE: 'THREE',
    COLLADA_LOADER: 'COLLADA_LOADER',
    TGA_LOADER: 'TGA_LOADER',
    MTL_LOADER: 'MTL_LOADER',
    OBJ_LOADER: 'OBJ_LOADER',
    DDS_LOADER: 'DDS_LOADER',
    ORBIT_CONTROLS: 'ORBIT_CONTROLS'
};
export const FILE_TYPE_JS = 'JS';
export const DEFAULT_THREE_JS_DEPS = {
    [THREE_JS_DEPS_KEYS.THREE]: {
        type: FILE_TYPE_JS,
        src: 'three/build/three.min.js'
    },
    [THREE_JS_DEPS_KEYS.COLLADA_LOADER]: {
        type: FILE_TYPE_JS,
        src: 'three/examples/js/loaders/ColladaLoader.js'
    },
    [THREE_JS_DEPS_KEYS.TGA_LOADER]: {
        type: FILE_TYPE_JS,
        src: 'three/examples/js/loaders/TGALoader.js'
    },
    [THREE_JS_DEPS_KEYS.MTL_LOADER]: {
        type: FILE_TYPE_JS,
        src: 'three/examples/js/loaders/MTLLoader'
    },
    [THREE_JS_DEPS_KEYS.OBJ_LOADER]: {
        type: FILE_TYPE_JS,
        src: 'three/examples/js/loaders/OBJLoader'
    },
    [THREE_JS_DEPS_KEYS.DDS_LOADER]: {
        type: FILE_TYPE_JS,
        src: 'three/examples/js/loaders/DDSLoader'
    },
    [THREE_JS_DEPS_KEYS.ORBIT_CONTROLS]: {
        type: FILE_TYPE_JS,
        src: 'three/examples/js/controls/OrbitControls.js'
    }
};
export const SUPPORTED_3D_MODELS = [
    { type: 'DAE', extension: 'dae' }
    // <Model3d> {type: 'OBJ', extension: 'obj'},
    // <Model3d> {type: 'FBX', extension: 'fbx'}
];
export const DEFAULT_TRANSLATIONS = {
    // Required
    [TranslationKeys.Open]: 'Open',
    [TranslationKeys.Close]: 'Close',
    [TranslationKeys.Download]: 'Download',
    [TranslationKeys.VisitUrl]: 'Visit URL',
    [TranslationKeys.PreviewImage]: 'Preview Image',
    [TranslationKeys.RenderErrorWhenOffline]: 'Sorry, we’re unable to complete your request. Looks like you’re offline.',
    [TranslationKeys.RenderErrorNoLowQualityPreview]: 'This file could not be viewed with your browser',
    [TranslationKeys.RenderError]: 'Something went wrong while loading this document.',
    [TranslationKeys.ThreeJsViewIn3d]: 'View in 3D',
    [TranslationKeys.ThreeJsWebglNotSupported]: '{{webGl}} not supported {{readMoreLink}}',
    [TranslationKeys.ThreeJsUnsupportedFile]: '{{modelExtension}} files cannot be viewed {{readMoreLink}}',
    [TranslationKeys.ThreeJsReadMore]: 'Read More',
    [TranslationKeys.ThreeJsLoadingModel]: 'Loading 3D Model',
    [TranslationKeys.ThreeJsFtueOrbitTitle]: 'Orbit',
    [TranslationKeys.ThreeJsFtueOrbitDescriptionMouse]: 'Left mouse button',
    [TranslationKeys.ThreeJsFtueOrbitDescriptionTouch]: 'One finger move',
    [TranslationKeys.ThreeJsFtueZoomTitle]: 'Zoom',
    [TranslationKeys.ThreeJsFtueZoomDescriptionMouse]: 'Scroll up or down',
    [TranslationKeys.ThreeJsFtueZoomDescriptionTouch]: 'Pinch',
    [TranslationKeys.ThreeJsFtuePanTitle]: 'Pan',
    [TranslationKeys.ThreeJsFtuePanDescriptionMouse]: 'Right mouse button',
    [TranslationKeys.ThreeJsFtuePanDescriptionTouch]: 'Two finger move',
    [TranslationKeys.ThreeJsRenderErrorTitle]: 'Failed to load model',
    [TranslationKeys.ThreeJsRenderErrorBody]: 'Something went wrong while trying to load your 3D model. Please try again.',
    [TranslationKeys.ToggleThumbnails]: 'Toggle thumbnails',
    [TranslationKeys.SwitchToSinglePageView]: 'Switch to single page view',
    [TranslationKeys.SwitchToContinuousScrollView]: 'Switch to continuous scroll view',
    [TranslationKeys.ZoomIn]: 'Zoom in',
    [TranslationKeys.ZoomOut]: 'Zoom out',
    [TranslationKeys.SearchComponentNoResults]: 'No results',
    [TranslationKeys.SearchComponentSearchDocument]: 'Search document',
    [TranslationKeys.SearchComponentIsUnavailable]: 'Unavailable',
    // Optional
    [TranslationKeys.OpenInPowerpoint]: 'Open in PowerPoint',
    [TranslationKeys.OpenInExcel]: 'Open in Excel',
    [TranslationKeys.OpenInWord]: 'Open in Word',
    [TranslationKeys.OfficeOnlineBarPowerpointMessage]: 'Animations, transition, speaker-notes and other native capabilities can be viewed in PowerPoint Online.',
    [TranslationKeys.OfficeOnlineBarExcelMessage]: 'Native and advanced spreadsheet capabilities can be used in Excel Online.',
    [TranslationKeys.OfficeOnlineBarWordMessage]: 'Native and advanced document capabilities can be used in Word Online.'
};
export const TRANSPARENT_IMAGE_SRC = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
//# sourceMappingURL=Constants.js.map